
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FolderItemProps } from ".";
import { loading, index } from "store/folder";

interface ApiFolderInputProps {
    parentId: -1 | number;
}

type ApiFolderOutputProps = OutputBaseProps<{ list: FolderItemProps[]; breadcrum: FolderItemProps[] }>

export const apiFolderIndex = async (data: ApiFolderInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFolderOutputProps>("/api/folders", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, breadcrum: res.data.breadcrum }));
    }
    return res;
};